import React from "react";
export default function SVGStorage() {
  return (
    <svg viewBox="0 0 207.014 207.014">
      <g fill="#000000">
        <path
          fill="#000000"
          d="M79.505,163.935H31.498c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h48.007c4.143,0,7.5-3.358,7.5-7.5
     C87.005,167.292,83.647,163.935,79.505,163.935z"
        />
        <path
          fill="#000000"
          d="M199.514,96.006h-40.508v-88.5c0-4.142-3.357-7.5-7.5-7.5H55.502c-4.143,0-7.5,3.358-7.5,7.5v88.5H7.5
     c-4.143,0-7.5,3.358-7.5,7.5v96.002c0,4.142,3.357,7.5,7.5,7.5h96.004h96.01c4.143,0,7.5-3.358,7.5-7.5v-96.002
     C207.014,99.364,203.656,96.006,199.514,96.006z M63.002,15.006h81.004v81h-40.502H63.002V15.006z M15,111.006h40.502h40.502
     v81.002H15V111.006z M192.014,192.008h-81.01v-81.002h40.502h40.508V192.008z"
        />
        <path
          opacity="0.7"
          fill="#000000"
          d="M120.004,171.435c0,4.142,3.357,7.5,7.5,7.5h48.006c4.143,0,7.5-3.358,7.5-7.5c0-4.142-3.357-7.5-7.5-7.5h-48.006
     C123.361,163.935,120.004,167.292,120.004,171.435z"
        />
        <path
          fill="#000000"
          d="M135.012,75.436c0-4.142-3.357-7.5-7.5-7.5H79.501c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h48.011
     C131.654,82.936,135.012,79.578,135.012,75.436z"
        />
      </g>
    </svg>
  );
}
